import { FunctionComponent, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { IUserCompanies, IUserProfile } from '../util/DataModelInterface';
import { useMsal } from '@azure/msal-react';
import * as storage from '../util/StorageUtil';
import { Dropdown, DropdownButton } from 'react-bootstrap';

interface ICompanySelectProps {
  onCompSelect: (c: IUserCompanies) => void;
}

export const CompanySelect: FunctionComponent<ICompanySelectProps> = (props) => {
  const { instance } = useMsal();

  const [user, setUser] = useState({} as IUserProfile);
  const [companies, setCompanies] = useState([] as IUserCompanies[]);
  const [selectedCompany, setSelectedCompany] = useState({} as IUserCompanies);

  useEffect(() => {
    let activeAccount = instance.getActiveAccount();
    if(activeAccount) {
        const userData = storage.getUser();
        console.log("CompanySelect - user: ", userData);
        let companies = userData?.companies ? userData.companies : [];
        let firstCompany = companies.length > 0 ? companies[0] : {} as IUserCompanies;
        let selectedCompany = userData?.selected_comp ? userData.selected_comp : firstCompany;
        setCompanies(companies);
        setSelectedCompany(selectedCompany);
        setUser(userData ? userData : {} as IUserProfile);
        props.onCompSelect(selectedCompany);
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectedComp = (id: string | null) => {
    let selected = companies.find(c => c.id === id);
    if (selected) {
      setSelectedCompany(selected);
      storage.setUser({...user, selected_comp: selected});
      props.onCompSelect(selected);
    }
  }

  return (
    <>

      <div className="role-bar mb-4 d-flex flex-lg-row flex-column">

        <div className="d-flex flex-row align-items-center">
          <p className="details-info me-4 mb-0 flex-row">
            <span className="key"><FormattedMessage id="reports.company"/>:</span>
            {selectedCompany.name &&
              <span className="value ms-2">{selectedCompany.name}</span>
            }
            {!selectedCompany.name &&
              <span className="value ms-2">
                <i className="fa fa-warning me-2"></i>
                <em><FormattedMessage id="user.status.nocompany"/></em>
              </span>
            }
          </p>

          {companies.length > 1 &&
            <DropdownButton id="dropdown-basic-button" title={
                <span>
                  <i className='fa fa-building me-2'></i>
                  <FormattedMessage id="button.change.company"/>
                </span>
            } onSelect={(e) => {handleSelectedComp(e)}}>
              {companies.map(c => <Dropdown.Item key={c.id} eventKey={c.id}>{c.name}</Dropdown.Item>)}
            </DropdownButton>
          }

        </div>
      </div>

    </>
  );
};